import axios from "axios";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL, headers: {
    Accept: "*/*", "Content-Type": "application/json",
  }, timeout: 30000,
});

export const gisClient = axios.create({
  baseURL: process.env.REACT_APP_SECTOR_API_URL, headers: {
    Accept: "*/*", "Content-Type": "application/json",
  }, timeout: 30000,
});

export default client;
